import { atom } from 'recoil'
import { recoilPersist } from 'recoil-persist'

const { persistAtom } = recoilPersist()

export const languageCurrentRecoil = atom({
  key: 'language',
  default: 'ja',
  effects_UNSTABLE: [persistAtom],
})
